module.exports = __webpack_public_path__ + "static/img/company-structure.9f3ce7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-structure.png
// module id = GvMe
// module chunks = 0